import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as a, unref as l, renderSlot as s, createBlock as m, createCommentVNode as n, createElementVNode as r } from "vue";
import { useBindCx as p } from "../../hooks/useBindCx.js";
import u from "../ScalarIcon/ScalarIcon.vue.js";
const f = ["aria-selected"], h = {
  key: 0,
  class: "flex h-fit items-center text-sm font-medium text-c-3 group-hover:text-c-1"
}, x = { class: "flex min-w-0 flex-1 flex-col gap-0.75" }, _ = { class: "flex items-center gap-1" }, g = { class: "flex-1 truncate zoomed:!whitespace-normal text-sm font-medium" }, v = {
  key: 0,
  class: "text-sm text-c-2"
}, k = {
  key: 0,
  class: "truncate zoomed:!whitespace-normal text-sm text-c-2"
}, S = /* @__PURE__ */ d({
  inheritAttrs: !1,
  __name: "ScalarSearchResultItem",
  props: {
    icon: {},
    selected: { type: Boolean }
  },
  setup(y) {
    const { cx: c } = p();
    return (e, i) => (t(), o("li", a(
      {
        "aria-selected": e.selected,
        role: "option"
      },
      l(c)(
        "group flex cursor-pointer gap-2.5 rounded px-3 py-1.5 no-underline hover:bg-b-2",
        { "bg-b-2": e.selected }
      )
    ), [
      e.icon ? (t(), o("div", h, [
        s(e.$slots, "icon", {}, () => [
          e.icon ? (t(), m(l(u), {
            key: 0,
            icon: e.icon,
            size: "sm"
          }, null, 8, ["icon"])) : n("", !0)
        ]),
        i[0] || (i[0] = r("span", null, " ", -1))
      ])) : n("", !0),
      r("div", x, [
        r("div", _, [
          r("div", g, [
            s(e.$slots, "default")
          ]),
          e.$slots.addon ? (t(), o("div", v, [
            s(e.$slots, "addon")
          ])) : n("", !0)
        ]),
        e.$slots.description ? (t(), o("div", k, [
          s(e.$slots, "description")
        ])) : n("", !0)
      ])
    ], 16, f));
  }
});
export {
  S as default
};
